import { useQuery } from '@pinia/colada';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { ApiError } from '../../../shared/api/client.ts';
import { playerSessionQuery } from '../../../shared/api/player.ts';
import { route } from '../../../shared/config/routes.ts';
import { startUserAction, userAction } from '../../../shared/observability/userAction.ts';

export function usePlayerSession({ asHost }: { asHost: boolean }) {
  const router = useRouter();
  const { data, error } = useQuery(playerSessionQuery);

  const session = computed(() => (data.value?.isHost === asHost ? data.value : undefined));
  const problem = computed(() => (error.value instanceof ApiError ? error.value.reason : ''));

  const rejoinGame = async () => {
    startUserAction(userAction.registrationRejoinGame);
    await router.push({ name: route.game, params: { gameCode: session.value?.gameCode } });
  };

  return { problem, session, rejoinGame };
}
